// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"a8a84b31","554":"3c5bd283","602":"fa469022"}[chunkId] + ".chunk.js";
};